import { schedulesMachine } from '@/features/schedules/state/schedules.machine';
import { defineFeature } from '@/lib/platform/system';

export const features = [
  defineFeature({
    id: 'schedules',
    machine: schedulesMachine,
    emits: [],
    handles: [],
    accepts: [
      'schedule.choose-route',
      'schedule.choose-direction',
      'schedule.choose-stop',
      'schedule.refresh-arrivals',
    ],
  }),
] as const;
